<lo-page-header
	title="What the assistant knows"
	subtitle="The facts Ana uses in every conversation, and where each one came from."
></lo-page-header>

@if (failed) {
<lo-notice
	tone="warning"
	heading="We could not read what the assistant knows"
	body="Reload the page to try again."
	data-testid="assistant-knowledge-unavailable"
></lo-notice>
} @else {
<section class="brands" [attr.aria-busy]="loading">
	@if (loading) { @for (_ of skeletonCards; track $index) {
	<lo-skeleton
		variant="block"
		height="calc(var(--lo-space-card) * 6)"
	></lo-skeleton>
	} } @for (brand of brands; track brand.id) {
	<lo-card
		[heading]="brand.name"
		[headingLevel]="2"
		data-testid="assistant-knowledge-brand"
	>
		<lo-status
			loCardActions
			[tone]="brand.isRegistration ? 'info' : 'neutral'"
		>
			{{ brand.roleLabel }}
		</lo-status>
		@if (!brand.facts.length) {
		<p class="lo-card__text">Nothing known yet.</p>
		} @for (fact of brand.facts; track fact.clearKey) {
		<div class="fact" data-testid="assistant-knowledge-fact">
			<span class="fact__label lo-type-text-sm-medium">
				{{ fact.label }}
			</span>
			<span class="fact__value lo-type-text-md">
				{{ fact.value }}
			</span>
			<div class="fact__meta">
				@if (fact.inheritedLabel) {
				<lo-chip>{{ fact.inheritedLabel }}</lo-chip>
				} @if (fact.conversationId) {
				<button
					lo-button
					variant="secondary"
					size="sm"
					type="button"
					loTooltip="Open this conversation in Ana"
					(click)="openConversation(fact)"
				>
					{{ fact.provenanceLabel }}
				</button>
				} @else if (fact.provenanceLabel) {
				<lo-chip>{{ fact.provenanceLabel }}</lo-chip>
				} @if (fact.canClear) {
				<button
					lo-button
					variant="secondary"
					size="sm"
					type="button"
					data-testid="assistant-knowledge-clear"
					[disabled]="clearingKey !== null"
					(click)="clear(brand, fact)"
				>
					Clear
				</button>
				}
			</div>
		</div>
		}
	</lo-card>
	}
</section>

<section class="voice" [attr.aria-busy]="loading">
	@if (loading) {
	<lo-skeleton
		variant="block"
		height="calc(var(--lo-space-card) * 3)"
	></lo-skeleton>
	} @else {
	<lo-card
		heading="The brand's voice"
		[headingLevel]="2"
		data-testid="assistant-knowledge-voice"
	>
		@if (voice) { @if (voice.summary) {
		<p class="lo-card__text">{{ voice.summary }}</p>
		} @if (voice.learnedLabel) {
		<p class="voice__learned lo-type-text-xs">
			{{ voice.learnedLabel }}
		</p>
		} } @else {
		<p class="lo-card__text">Not learned yet.</p>
		}
	</lo-card>
	}
</section>
}
